module.exports = __webpack_public_path__ + "media/img/logo-christmas-18e693e67b915b62224d8b5b81f38c27.png";